<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Ricerca Rilievo">
                <button type="button" class="btn btn-outline-primary mt-3" [routerLink]="['../crea']">
                    <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    <span class="d-none d-md-inline-block">Inserisci rilievo</span>
                </button>
            </app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <form class="form" role="form" [formGroup]="criteriaForm" (ngSubmit)="submitForm(true)">
                        <div class="form-row pt-2">
                            <h6 class="col-12">Ricerca rilievo</h6>
                            <div class="form-group col-md-3">
                                <label for="idRilievo">ID rilievo</label>
                                <input class="form-control" id="idRilievo" formControlName="idRilievo" type="number">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="nome">Nome rilievo</label>
                                <input class="form-control" id="nome" formControlName="nome" type="text">
                            </div>
                            <div class="form-group col-md-6">
                                <app-toolkit-datepicker
                                    label="Data inizio rilievo (a partire da)"
                                    aria-label="Data inizio rilievo"
                                    formControlName="dataInizioRilievo"
                                    [disabled]="criteriaForm.controls['dataInizioRilievo'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                            <div class="form-group col-md-6">
                                <app-toolkit-datepicker
                                    label="Data fine rilievo (entro il)"
                                    aria-label="Data inizio rilievo"
                                    formControlName="dataFineRilievo"
                                    [disabled]="criteriaForm.controls['dataFineRilievo'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-outline-primary" (click)="resetForm()">Pulisci</button>
                            <button type="submit" class="btn btn-primary">Ricerca</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card mt-4">
                <div class="card-body">
                    <h6 id="table_description">Risultati ricerca</h6>
                    <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                        <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Nome rilievo</th>
                                    <th scope="col">Soggetto esecutore</th>
                                    <th scope="col">Data inizio</th>
                                    <th scope="col">Data fine</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tableData">
                                    <td>{{ item.idRilievo }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.soggettoEsecutore }}</td>
                                    <td>{{ item.dataInizioRilievo | date: 'dd/MM/yyyy' }}</td>
                                    <td>{{ item.dataFineRilievo | date: 'dd/MM/yyyy' }}</td>
                                    <td class="actions">
                                        <button aria-label="accedi al dettaglio" type="button" (click)="goToRilievo(item.idRilievo)" class="btn btn-xs btn-link" container="body" ngbTooltip="Accedi al dettaglio">
                                            <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!tableData.length">
                                    <td colspan="6"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination
                        *ngIf="tableData.length"
                        [(page)]="paginator.page"
                        [pageSize]="paginator.size"
                        [collectionSize]="paginator.total"
                        (pageChange)="onPageChange($event)"
                        [maxSize]="5"
                        ></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>